<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-archive mr-2" />Draft Pindah Gudang</h5>
            <hr />
            <b-row>
                <b-col md="6">
                    Perpindahan dari gudang <strong>{{ data.from }} - {{ data.from_office }}</strong><br />
                    menuju gudang <strong>{{ data.to }} - {{ data.to_office }}</strong><br />
                    Divisi barang <strong>{{ data.division }}</strong><br />
                    Total <strong>{{ data.total_item }}</strong> barang
                </b-col>
                <b-col md="6" class="text-right">
                    <b-button variant="danger" @click="cancelPindahBarang">
                        <i class="fa fa-times mr-2" />Batalkan
                    </b-button>
                    <b-button variant="success" class="ml-2" @click="promptPindahBarang">
                        <i class="fa fa-check mr-2" />Finalisasi
                    </b-button>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col md="6">
                    <b-input-group>
                        <b-input v-model="input.noFaktur" maxlength="100" style="max-width: 250px" placeholder="Input No. Faktur..." @keydown.enter="addItem" />
                        <b-input-group-append>
                            <b-button variant="dark" @click="addItem" :disabled="isEditing">Tambah Barang</b-button>
                        </b-input-group-append>
                        <b-button variant="success" class="ml-2" @click="openModalImport">Import Excel</b-button>
                    </b-input-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting
                :items="data.items"
                :fields="fields"
                :busy="isBusy"
                responsive class="my-3"
                @sort-changed="onSortChanged"
            >
                <template v-slot:empty>
                    Belum ada barang yang dipindahkan.
                </template>
                <template v-slot:cell(no)="row">
                    {{ row.index + 1 }}.
                </template>
                <template v-slot:cell(barang)="row">
                    {{ row.item.type }} <span v-if="row.item.year != null">({{ row.item.year }})</span>
                    <div class="small text-muted">
                        {{ row.item.kind }} - {{ row.item.brand }}
                    </div>
                </template>
                <template v-slot:cell(noFakturImei)="row">
                    {{ row.item.no_faktur_pgi }}
                    <div class="small text-muted">
                        {{ row.item.imei_sn }}<br />
                    </div>
                </template>
                <template v-slot:cell(action)="row">
                    <b-button size="sm" variant="danger" v-b-tooltip.hover.top title="Hapus" :disabled="isEditing" @click="removeItem(row.item)">
                        <i class="fa fa-fw fa-times" />
                    </b-button>
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" @page-change="onPageChange" />
        </b-card>
        <b-modal id="m-confirm-movement" title="Finalisasi Dokumen" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="No. Ref Faktur" description="Wajib diisi. No. Ref akan ditampilkan di faktur pindah barang. Maks. 20 karakter.">
                <b-input v-model="movement.noRef" maxlength="20" />
            </b-form-group>
            <b-form-group label="Tanggal Perpindahan" description="Wajib diisi. Tanggal perpindahan yang akan dimunculkan di cetakan faktur pindah barang.">
                <b-input v-model="movement.moveDate" type="date" />
            </b-form-group>
            <b-form-group label="Catatan Perpindahan">
                <b-input v-model="movement.note" maxlength="200" />
            </b-form-group>
            <div class="text-right mt-4">
                <b-button variant="primary" :disabled="isSubmitting" @click="execPindahBarang">
                    Pindahkan Barang
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-upload" title="Upload Excel" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group>
                <b-form-file v-model="input.excelFile" :state="Boolean(input.excelFile)" placeholder="Pilih file excel" drop-placeholder="Tarik dan lepas file disini" accept=".xlsx, .xls" />
                <small class="text-muted">* Kolom A: Nomor Faktur</small> <br />
                <small class="text-muted">* Baris pertama akan diabaikan (anggap sebagai header)</small>
            </b-form-group>
            <b-button variant="primary" class="mt-2" @click="uploadExcel" :disabled="!input.excelFile || isUploadingExcel">
                <i class="fa fa-upload mr-2" v-if="!isUploadingExcel" />
                {{ isUploadingExcel ? 'Mengupload...' : 'Unggah' }}
            </b-button>
        </b-modal>
        <b-modal id="m-barcode" title="Cetak Barcode" centered no-close-on-backdrop no-close-on-esc hide-footer hide-header-close>
            Silahkan cetak barcode dibawah ini. Barcode telah tersimpan pada menu Log Barcode.
            <br /><br />
            <iframe :src="getBarcodeLink()" height="300px" width="100%" />
            <div class="mt-4">
                <b-row>
                    <b-col md="12" class="text-right">
                        <b-button variant="primary" @click="finishPindahBarang">
                            Tutup
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
        <b-modal id="m-print" title="Cetak Invoice" centered hide-footer no-close-on-backdrop no-close-on-esc hide-header-close>
            Invoice berhasil dibuat. Tekan bagian "Sinar Mutiara Cell" untuk mencetak.
            <iframe :src="getInvoiceLink()" height="300px" width="100%" />
            Pastikan pindah barang sudah tercetak dengan baik sebelum melanjutkan.
            <div class="mt-4">
                <b-row>
                    <b-col md="6">
                        <b-button variant="dark" :disabled="invoiceSizeCooldown" @click="toggleInvoiceSize">
                            Print {{ invoiceSize == 'A5' ? 'A4' : 'A5' }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button variant="primary" @click="openBarcodeModal">
                            Lihat Barcode
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
    </div>
</template>

<script>

export default {
    data() {
        return {

            initStatus: 0,
            isSubmitting: false,
            isEditing: false,
            isBusy: false,
            isUploadingExcel: false,

            invoiceLink: "",
            invoiceLinkA4: "",

            data: {
                from: "",
                to: "",
                total_item: 0,
                division: "",
                items: [],
                from_office: "",
                to_office: ""
            },

            input: {
                noFaktur: "",
                excelFile: null
            },

            movement: {
                note: "",
                noRef: "",
                moveDate: ""
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "no", label: "No." },
                { key: "barang", label: "Barang", sortable: true },
                { key: "noFakturImei", label: "No. Faktur & IMEI / SN", sortable: true },
                { key: "action", label: "Aksi" }
            ],

            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            invoiceSize: 'A5',
            invoiceSizeCooldown: false,

            barcodeLink: "",
            barcodeLinkDamage: "",

            barcodeType: 'barcode',
            barcodeToggleCooldown: false

        }
    },

    methods: {

        init() {

            this.initStatus = 0

            let getData = this.getDraftItems()
            .catch(error => this.$helper.parseError(this, error))

            Promise.all([getData]).then(() => {
                this.initStatus = 1
            })
            .catch(_ => this.initStatus = -1)

        },

        addItem() {

            if(this.$helper.isBlank(this.input.noFaktur)) {
                return this.$helper.toastError(this, "Mohon mengisi nomor faktur!")
            }

            let payload = {
                no_faktur_pgi: this.input.noFaktur,
                move_id: this.$route.params.id
            }

            this.isEditing = true

            this.$axios.post("move-warehouse/add-item", payload).then(_ => {
                this.$helper.toastSuccess(this, "Barang berhasil ditambahkan!")
                this.input.noFaktur = ""
                this.getDraftItems()
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isEditing = false)

        },

        openModalImport() {
            this.input.excelFile = null
            this.$bvModal.show('m-upload')
        },

        uploadExcel() {

            if(!this.input.excelFile) {
                return this.$helper.toastError(this, "Mohon pilih file Excel terlebih dahulu!")
            }

            let formData = new FormData()
            formData.append("move_id", this.$route.params.id)
            formData.append("file", this.input.excelFile)

            this.isUploadingExcel = true

            this.$axios.post("move-warehouse/upload-excel", formData, {
                headers: { "Content-Type": "multipart/form-data" }
            }).then(_ => {
                this.$helper.toastSuccess(this, "Upload Excel berhasil!")
                this.input.excelFile = null
                this.$bvModal.hide('m-upload')
                this.getDraftItems()
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isUploadingExcel = false)

        },

        removeItem(item) {

            let confirmed = confirm(`Hapus ${item.type} (NF ${item.no_faktur_pgi}) dari pindah barang ini?`)
            if(!confirmed) return

            let payload = {
                move_detail_id: item.id,
                move_id: this.$route.params.id
            }

            this.isEditing = true

            this.$axios.post("move-warehouse/remove-item", payload).then(_ => {
                this.$helper.toastSuccess(this, "Barang berhasil dihapus!")
                this.getDraftItems()
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isEditing = false)

        },

        cancelPindahBarang() {

            let isConfirmed = confirm("Batalkan pindah barang ini? Draft akan dihapus dan barang-barang akan dikembalikan ke status semula!")
            if(!isConfirmed) return

            let payload = {
                id: this.$route.params.id
            }

            this.$axios.post("move-warehouse/cancel", payload).then(_ => {
                this.$router.push({ path: "/pindah-gudang" })
            })
            .catch(error => this.$helper.parseError(this, error))

        },

        promptPindahBarang() {

            if(this.data.items.length == 0) {
                return this.$helper.toastError(this, "Belum ada barang yang akan dipindahkan!")
            }

            this.movement.noRef = ""
            let tzoffset = (new Date()).getTimezoneOffset() * 60000
            let localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1)
            this.movement.moveDate = localISOTime.substring(0, 10)
            this.movement.note = ""

            this.$bvModal.show("m-confirm-movement")

        },

        getBarcodeLink() {
            if(this.barcodeType == 'barcode'){
                return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLink}`
            }
            else{
                return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLinkDamage}`
            }
        },

        toggleBarcodeType() {
            this.barcodeToggleCooldown = true
            if(this.barcodeType == 'barcode') this.barcodeType = 'damage'
            else this.barcodeType = 'barcode'
            setTimeout(function(){
                this.barcodeToggleCooldown = false
            }.bind(this),2000);
        },

        execPindahBarang() {

            if(typeof payload === "string") return this.$helper.toastError(this, payload)
            if(this.$helper.isBlank(this.movement.noRef)) {
                return this.$helper.toastError(this, "Mohon mengisi nomor ref faktur!")
            }
            if(this.$helper.isBlank(this.movement.moveDate)) {
                return this.$helper.toastError(this, "Mohon mengisi tanggal dokumen!")
            }

            let isConfirmed = confirm("Jalankan pindah gudang ini? Proses ini tidak dapat dibatalkan!")
            if(!isConfirmed) return

            let payload = {
                id: this.$route.params.id,
                note: this.movement.note,
                no_ref: this.movement.noRef,
                move_date: this.movement.moveDate
            }

            this.isSubmitting = true
            this.$axios.post("move-warehouse/confirm", payload).then(res => {

                let result = res.data.data
                if(result.fail == 0){
                    this.$helper.toastSuccess(this, `Pindah gudang berhasil dijalankan! ${result.success} barang berhasil dipindahkan.`)
                }
                else{
                    this.$helper.toastSuccess(this, `Pindah gudang berhasil dijalankan! ${result.success} barang berhasil dipindahkan dan ${result.fail} barang gagal dipindahkan.`)
                }
                this.$bvModal.hide("m-confirm-movement")
                this.invoiceLink = `${this.$BASE_PRINT_FILE_PATH}/${res.data.data.link}`
                this.invoiceLinkA4 = `${this.$BASE_PRINT_FILE_PATH}/${res.data.data.linka4}`
                this.barcodeLink = res.data.data.barcodeLink
                this.barcodeLinkDamage = res.data.data.barcodeLinkDamage
                this.$bvModal.show("m-print")

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        openBarcodeModal() {
            this.$bvModal.hide("m-print")
            this.$bvModal.show("m-barcode")
        },

        finishPindahBarang() {
            this.$router.push({ path: "/pindah-gudang" })
        },

        getDraftItems(page){
            this.isBusy = true

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if(!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("move-warehouse/draft/" + this.$route.params.id + param).then(res => {
                this.data.items = res.data.data.data.items.map(item => {
                    return {
                        id: item.id,
                        type: item.type,
                        brand: item.brand,
                        kind: item.kind,
                        year: item.year,
                        no_faktur_pgi: item.no_faktur,
                        imei_sn: item.no_faktur_string
                    }
                })
                this.totalRows = res.data.data.data.total
                this.data.from = res.data.data.from
                this.data.to = res.data.data.to
                this.data.total_item = res.data.data.data.total
                this.data.division = res.data.data.division
                this.data.from_office = res.data.data.from_office
                this.data.to_office = res.data.data.to_office
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => { this.isBusy = false })
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getDraftItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getDraftItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getDraftItems()
        },

        getInvoiceLink() {
            if(this.invoiceSize == 'A5'){
                return this.invoiceLink
            }
            else{
                return this.invoiceLinkA4
            }
        },

        toggleInvoiceSize() {
            this.invoiceSizeCooldown = true
            if(this.invoiceSize == 'A5') this.invoiceSize = 'A4'
            else this.invoiceSize = 'A5'
            setTimeout(function(){
                this.invoiceSizeCooldown = false
            }.bind(this),2000);
        },

    },
    created() {

        this.init()

        let tzoffset = (new Date()).getTimezoneOffset() * 60000
        let localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1)
        this.movement.moveDate = localISOTime.substring(0, 10)

    }
}
</script>

<style>

</style>
